import React from 'react';

export const LocaleProvider = React.createContext({ code: 'en-US' });
